<div [formGroup]="form">
  <div>
    <app-content-header *ngIf="formArray.controls.length > 0"
      text="Camp Services"></app-content-header>
    <div
      style="margin-bottom: 0.5rem"
      *ngFor="let formGroup of formArray.controls; let i = index"
    >
      <app-reservation-service-tile-form
        [formGroup]="formGroup"
        [serviceCategory]="getServiceCategory(i)"
        [reservationRequest]="reservationRequest"
        (selectedServices)="handleSelectedServices($event)"
        [isErrorOnSave]="isErrorOnSave"
      ></app-reservation-service-tile-form>
    </div>
    <!-- <div class="service-info-label">Please note:</div>
    <div class="interview-request-content mb-4">Why can't I select other option ? ……..
    </div> -->
    <ng-container *ngIf="reservationRequest?.selectedLocation?.homeBuddiesUrl">
      <app-content-header text="In-Home Services"></app-content-header>
      <div style="margin-bottom: 0.5rem">
        <span>
          <a
            class="link"
            [href]="reservationRequest?.selectedLocation?.homeBuddiesUrl"
            [ngClass]="{ disabled: hasSelectionOnCoreServices() }"
            target="_blank"
          >Click Here</a>
          to book dog walking and pet sitting services!
        </span>
      </div>
    </ng-container>
    <hr class="mt-5" />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!canSave()"
      >
        Continue
      </button>
    </footer>
  </div>
</div>
